import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import axios from '@/services/axios'
import router from '@/router'

const store = createStore({
  plugins: [
    createPersistedState()
  ],
  state: {
    authenticated: false,
    user: null,
    token: null,
    role: null,
    app: {
      name: process.env.VUE_APP_NAME,
      name_en: process.env.VUE_APP_NAME_EN
    }
  },
  mutations: {
    authenticateUser(state, data) {
      state.authenticated = true;
      state.token = data.token;
      state.user = data.user;
      state.role = data.role;
    },
    unauthenticateUser(state) {
      state.authenticated = false;
      state.token = null;
      state.user = null
      state.role = null
    },
  },
  actions: {
    async login({ commit }, credentials) {
      await axios.get('sanctum/csrf-cookie');
      const res = await axios.post('api/login', credentials);
      commit('authenticateUser', res.data)
      localStorage.setItem('token', res.data.token)
      localStorage.setItem('role', res.data.role)

      await axios.get('api/user');
      await router.push({ name: 'dashboard' })
    },
    async logout({ commit }) {
      await axios.post('api/logout', {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      });
      commit('unauthenticateUser');
      localStorage.removeItem('token')
      localStorage.removeItem('role')
      await router.push({ name: 'login' })
    },

  },
  getters: {
    isAuthenticated(state) {
      return state.authenticated;
    },
    user(state) {
      return state.user;
    },
    userToken(state) {
      return state.token;
    }
  },
})

export default store
 